import config from '../config'
import { updateBusinessDetails } from '../api'
import fetcher from '../api/fetcher.mjs'
import {
  buildProfileUpdatePlan,
  SavedUserProfile,
} from './guestHydrationOrchestrator'
import { GuestInvoiceDraftPayload } from './guestInvoiceDraftStorage'

const uploadBusinessLogo = async (logo: string): Promise<void> => {
  await fetcher(`${config.REACT_APP_API_URL}/api/user/business/logo`, {
    method: 'POST',
    body: JSON.stringify({ logo }),
  })
}

export const executeProfileOverwriteAccept = async (
  draft: GuestInvoiceDraftPayload,
  profile: SavedUserProfile,
  accountEmail?: string,
): Promise<{ ok: true } | { ok: false; error: unknown }> => {
  try {
    const plan = buildProfileUpdatePlan(profile, draft, 'accept', accountEmail)
    if (plan.shouldUpdate) {
      if (plan.businessDetailsPatch) {
        const profileResult = await updateBusinessDetails('/api/user/business', {
          arg: { body: plan.businessDetailsPatch },
        })
        if (!profileResult) {
          throw new Error('Could not update profile from guest draft')
        }
      }
      if (plan.logoUpload) {
        await uploadBusinessLogo(plan.logoUpload)
      }
    }
    return { ok: true }
  } catch (error) {
    return { ok: false, error }
  }
}
